export default __webpack_public_path__ + "static/media/profile_about.26a2db66.jpg";